import React, { useState, useEffect, useRef, useCallback  ,useMemo} from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { baseUrl } from "../../config";
import axios from 'axios';
import Summary_Card from "../Card/Summary_Card";
import Empty_Screen_Card from "../Card/Empty_Screen_Card";
import summaryImage from "../Images/summary.png";
import { Bug } from 'lucide-react';
import ReactPlayer from "react-player";
import { Play, Pause, Volume2, VolumeX, Expand } from "lucide-react";
const Share_Video_Summary = ({ videoUrl, logUrl, websiteId, videoId }) => {

    const { footprintId } = useParams();
  const [stickers, setStickers] = useState([]);



    const [filter, setFilter] = useState("Action Logs");

    const [metrics, setMetricsData] = useState();


    const handleFilterClick = (status) => {
        setFilter(status);
    };
    const [data, setData] = useState();
    let pendingRuns =
        data?.occurrences - (data?.successCount + data?.failureCount);

    useEffect(() => {
        // Fetch data from the API and set the input field values
        const fetchData = async () => {
            try {
                const response = await axios.get(
                    `${baseUrl}/footprint/foot/${footprintId}`
                );
                const footprint = response.data;
                setData(footprint);
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };

        fetchData();
    }, []);



    //--------------> video section
    const [summaryLogs, setSummaryLogs] = useState("");
    const [summary, setSummary] = useState("");
    const [isSummarizing, setIsSummarizing] = useState(false);
    const [isHide, setIsHide] = useState(false);
    const [video, setVideo] = useState();
    const [actionLog, setActionLog] = useState();
    const [copiedSummary, setCopiedSummary] = useState("Copy");
    const videoRef = useRef(null);
    const [currentTime, setCurrentTime] = useState(0);
    const [isPlaying, setIsPlaying] = useState(false);
    const [logs, setLogs] = useState([]);
    const [copy, setCopy] = useState("Copy");




    //New implementation.
    const playerRef = useRef(null);
    const containerRef = useRef(null);
    const progressBarRef = useRef(null);

    const [playing, setPlaying] = useState(false);
    const [muted, setMuted] = useState(false);
    const [progress, setProgress] = useState(0);
    const [duration, setDuration] = useState(1);

    const togglePlay = () => setPlaying((prev) => !prev);
    const toggleMute = () => setMuted((prev) => !prev);
    const toggleFullscreen = () => {
        if (document.fullscreenElement) {
            document.exitFullscreen();
        } else if (containerRef.current) {
            containerRef.current.requestFullscreen();
        }
    };

    const seekTo = (seconds) => {
        if (playerRef.current) {
            playerRef.current.seekTo(seconds, "seconds");
            setProgress(seconds);
        }
    };


    
    const formatTime = (seconds) => {
        if (isNaN(seconds)) return "00:00";
        const mins = Math.floor(seconds / 60);
        const secs = Math.floor(seconds % 60);
        return `${String(mins).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
      };
    
      const handleBarClick = useCallback(
        (e) => {
          const bar = progressBarRef.current;
          if (!bar) return;
    
          const rect = bar.getBoundingClientRect();
          const clickX = e.clientX - rect.left;
          const percentage = clickX / rect.width;
          const newTime = duration * percentage;
          seekTo(newTime);
        },
        [duration]
      );
    
     
      
    
    
      const errorMarkers = useMemo(() => {
        return stickers.map((timestamp, index) => {
          const left = `${(timestamp / duration) * 100}%`;
          return (
            <div
              key={index}
              title={`Fail at ${formatTime(timestamp)}`}
              className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 cursor-pointer bg-[#414141] rounded-lg p-1"
              style={{ left }}
              onClick={(e) => {
                e.stopPropagation();
                seekTo(timestamp);
              }}
            >
              <Bug
                size={20}
                className="text-red-600 drop-shadow transition-transform duration-200 hover:scale-150"
              />
            </div>
          );
        });
      }, [stickers, duration]);
  

    // Function to fetch and parse log data from S3
    // useEffect(() => {
    //     const fetchLogs = async () => {
    //         try {
    //             const response = await fetch(logUrl);
    //             const text = await response.text();
    //             const logLines = text.split("\n").filter(Boolean); // Split log by lines and filter out empty lines

    //             const parsedLogs = logLines.map((log) => {
    //                 const match = log.match(/\[(\d+)ms\]/); // Extract the milliseconds from the log string
    //                 const milliseconds = match ? parseInt(match[1], 10) : 0;
    //                 const content = log.split(" - ").slice(2).join(" - "); // Extract log content after milliseconds
    //                 return { milliseconds, content };
    //             });
    //             setLogs(parsedLogs);
    //         } catch (error) {
    //             console.error("Error fetching logs:", error);
    //         }
    //     };

    //     fetchLogs();
    // }, [logUrl]);



      useEffect(() => {
        const fetchLogs = async () => {
          try {
            const response = await fetch(logUrl);
            const text = await response.text();
            const logLines = text.split("\n").filter(Boolean); // Split log by lines and filter out empty lines
    
            console.log("ye logs hai", logLines)
            const parsedLogs = logLines.map((log) => {
              const match = log.match(/\[(\d+)ms\]/); // Extract the milliseconds from the log string
              let milliseconds = match ? parseInt(match[1], 10) : 0;
              const seconds = milliseconds / 1000; 
              milliseconds=seconds
              const content = log.split(" - ").slice(2).join(" - "); // Extract log content after milliseconds
              return { milliseconds, content };
            });
    
            const failedTimestamp = parsedLogs
              .filter(log => log.content.includes("Error performing action") || log.content.includes("dropIndex not found"))
              .map(log => log.milliseconds); // Extract milliseconds for matching logs
    
            setStickers(failedTimestamp)
    
            console.log("Failed video timestamps':", failedTimestamp);
            setLogs(parsedLogs);
          } catch (error) {
            console.error("Error fetching logs:", error);
          }
        };
    
        fetchLogs();
      }, [logUrl]);

    // Function to handle time updates from the video
    const handleTimeUpdate = () => {
        const video = videoRef.current;
        if (video) {
            setCurrentTime(video.currentTime * 1000); // Convert video time to milliseconds
        }
    };

    // Play/Pause Video
    const togglePlayPause = () => {
        const video = videoRef.current;
        if (video) {
            if (isPlaying) {
                video.pause();
            } else {
                video.play();
            }
            setIsPlaying(!isPlaying);
        }
    };

    // Seek video to a specific time
    // const seekTo = (time) => {
    //     const video = videoRef.current;
    //     if (video) {
    //         video.currentTime = time / 1000; // Convert milliseconds to seconds
    //     }
    // };




    // Get the logs that should be visible based on the video time
    // const getVisibleLogs = () => {
    //   return logs?.filter((log) => currentTime >= log.milliseconds);
    // };


    const getVisibleLogs = () => {
        if (!Array.isArray(logs)) {
            console.error("logs is not an array:", logs);
            return []; // Return an empty array to prevent errors
        }
        return logs.filter((log) => currentTime >= log.milliseconds);
    };


    const visibleLogs = getVisibleLogs();


    const fetchVideo = async () => {
        try {
            const response = await axios.get(`${baseUrl}/videos/${videoId}`);

            console.log("Get request for video successful!", response.data);
            if (response?.data?.summaryUrl) {
                await fetchSummariseLogs(response?.data?.summaryUrl);
            }
            setVideo(response.data);
        } catch (error) {
            console.log("Error in fetching data", error.response);
        }
    };

    const handleSummarizeLogs = async () => {
        setIsSummarizing(true); // Set loading state
        const userId = localStorage.getItem("userId");
        try {
            const response = await axios.post(`${baseUrl}/ai/summary`, {
                logs: actionLog,
                userId,
                websiteId,
                footprintId,
                videoId,
            });

            // Assuming the API returns the summary in the response
            setSummary(response.data.summary);
            setIsSummarizing(false); // Unset loading state
            setIsHide(true);
            // window.location.reload();
            fetchVideo();
        } catch (error) {
            console.error("Error summarizing logs:", error);
            setSummary("Failed to summarize logs.");
            setIsSummarizing(false); // Unset loading state
        }
    };

    const fetchActionLogs = async () => {
        try {
            const response = await fetch(logUrl);
            console.log(response);
            const logText = await response.text();
            setActionLog(logText);
        } catch (error) {
            console.error("Error fetching logs:", error);
            setActionLog("Failed to load logs.....");
        }
    };

    const fetchSummariseLogs = async (logs) => {
        try {
            const response = await fetch(logs);
            console.log("response from sumamry Url", response);
            const summaryLogs = await response.text();
            setSummaryLogs(summaryLogs);
        } catch (error) {
            console.error("Error fetching logs:", error);
            setLogs("Failed to load logs.....");
        }
    };

    console.log("logs", logs, "logUrl", logUrl,);
    useEffect(() => {
        fetchVideo();
        fetchActionLogs();
    }, [logUrl, videoId]);

    const copyToSummary = () => {
        navigator.clipboard
            .writeText(summaryLogs)
            .then(() => {
                // alert("Logs copied to clipboard!");
                setCopiedSummary("Copied!!"); // Show "Copied!" message
                setTimeout(() => {
                    setCopiedSummary("Copy"); // Hide after 2 seconds
                }, 1500);
            })
            .catch((err) => {
                console.error("Failed to copy logs: ", err);
            });
    };





  // Load video metadata and calculate stickers
  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const handleMetadata = () => {
      setDuration(video.duration * 1000);
    };

    video.addEventListener("loadedmetadata", handleMetadata);
    return () => video.removeEventListener("loadedmetadata", handleMetadata);
  }, [videoUrl]);




    //------------> Metrics Data------------------>


    useEffect(() => {
        // Fetch data from the API and set the input field values
        const fetchData = async () => {
            console.log("ye start hua")
            try {
                const response = await axios.get(
                    `${baseUrl}/videos/${videoId}/metrics`
                );
                console.log("ye hai kya")
                const metrics = response.data;
                console.log(metrics, "kya hai ye")
                setMetricsData(metrics);
            } catch (error) {
                console.error("Error fetching data:", error);
            }
        };
        fetchData();

    }, []);






    return (
        <>
            <div className="header-section">

                <div className="info flex flex-col gap-6 bg-layout rounded-lg border border-layout-border shadow-[0px_1px_2px_0px_#0000000D] p-6">





                    <div className="setup-guide">
                        <div className="inner-setup-guide text-color-gray-light grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-6">
                            <Summary_Card
                                // title="Performance Score"
                                title={<>
                                    Performance  <br />
                                    Score
                                </>}

                                value={`${(metrics?.data?.pageSpeed ?? 0)}/100`}
                                content="An explanation of performance score"
                                tooltipMessage="Performance score is the weighted average of the metric scores (LCP, INP and CLS)"

                            />
                            <Summary_Card
                                // title="Largest Contentful Paint (LCP)"
                                title={<>
                                    LCP
                                </>}
                                value={`${(metrics?.data?.lcp ?? 0)} ms`}
                                content="An explanation of page speed"
                                tooltipMessage="Largest
                                    Contentful Paint Measures loading performance. Aim for under 2.5s for a good experience."

                            />
                            <Summary_Card
                                // title="Cumulative Layout Shift (CLS)"
                                title={<>
                                    CLS
                                </>}
                                value={`${(metrics?.data?.cls ?? 0)} ms`}

                                content="The total number of times."

                                tooltipMessage="Cumulative Layout Shift Measures visual stability. Lower is better; aim for under 0.1."
                            />
                            <Summary_Card
                                title="Page Size"
                                value={`${(metrics?.data?.pageSize ?? 0)}`}

                                content="Don’t have enough data to give."
                                tooltipMessage="Overall data based on Lighthouse metrics"
                            />
                        </div>
                    </div>

                    <div className="video-section ">


                        <div className="flex-grow">
                            {/* <video
                                ref={videoRef}
                                className="w-full h-full object-cover rounded-xl border"
                                controls
                                src={videoUrl && videoUrl}
                                onTimeUpdate={handleTimeUpdate}
                                alt="Test Case Video"
                            /> */}


                            <div
                                ref={containerRef}
                                className="relative w-full  mx-auto bg-gray-900 rounded-lg  overflow-hidden"
                            >
                                {/* Player */}
                                <ReactPlayer
                                    ref={playerRef}
                                    url={videoUrl && videoUrl}
                                    playing={playing}
                                    muted={muted}
                                    controls={false}
                                    width="100%"
                                    height="auto"
                                    onProgress={({ playedSeconds }) => {
                                        setProgress(playedSeconds); setCurrentTime(playedSeconds); // Convert video time to milliseconds
                                    }}
                                    onDuration={(dur) => setDuration(dur || 1)}
                                    onEnded={() => setPlaying(false)}
                                    progressInterval={100}

                                />

                                {/* Controls */}
                                <div className="flex items-center justify-between px-3 py-2 text-white bg-black/70">
                                    {/* Play/Pause */}
                                    <button onClick={togglePlay}>{playing ? <Pause size={16} /> : <Play size={16} />}</button>

                                    {/* Progress Section */}
                                    <div className="relative flex-1 mx-4 flex items-center gap-2">
                                        <span className="text-xs min-w-[40px]">{formatTime(progress)}</span>

                                        {/* Clickable Progress Bar */}
                                        <div
                                            ref={progressBarRef}
                                            onClick={handleBarClick}
                                            className="relative flex-1 h-2 bg-gray-700 rounded-full cursor-pointer"
                                        >
                                            {/* Filled Progress - White Color */}
                                            <div
                                                className="absolute top-0 left-0 h-full bg-white rounded-full transition-all duration-150"
                                                style={{ width: `${(progress / duration) * 100}%` }}
                                            />
                                            {/* Error markers */}
                                            {errorMarkers}
                                        </div>

                                        <span className="text-xs  ml-4 min-w-[40px]">{formatTime(duration)}</span>
                                    </div>

                                    {/* Mute/Unmute */}
                                    <div className="flex gap-4">
                                        <button onClick={toggleMute}  >
                                            {muted ? <VolumeX size={16} /> : <Volume2 size={16} />}
                                        </button>

                                        {/* Fullscreen */}
                                        <button onClick={toggleFullscreen}>
                                            <Expand size={14} />
                                        </button>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="log-section">
                        <div className="logs-category-section">
                            <div className="top-section flex items-center gap-6 ">
                                <div className="title text-3xl text-color-gray-light font-bold">Logs</div>

                                <div className="inner-section flex justify-between ">
                                    <div className="filter-section">
                                        <div className="filter-items">
                                            <div className="items flex justify-between bg-layout border border-layout-border font-medium text-sm items-center gap-2.5  rounded-md p-[5px] text-filter-color">
                                                <div
                                                    className={`item-1 rounded-[4px] px-3 py-1.5  cursor-pointer transition ease-out duration-300 ${filter == "Action Logs" ? "bg-white shadow-[0px_1px_2px_0px_#0000000D] text-color-gray-light font-semibold " : ""
                                                        }`}
                                                    onClick={() => handleFilterClick("Action Logs")}
                                                >
                                                    Action Logs
                                                </div>
                                                {/* <div
                          className={`item-2 rounded-[4px] px-3 py-1.5 cursor-pointer ${filter === "Summary Logs" ? "bg-white shadow-[0px_1px_2px_0px_#0000000D] text-color-gray-light transition ease-out duration-300" : ""
                            }`}
                          onClick={() => handleFilterClick("Summary Logs")}
                        >
                          Summary Logs
                        </div> */}


                                            </div>
                                        </div>
                                    </div>




                                </div>
                            </div>
                            <div className="logs-content">
                                <div className="setup-guide mt-5 flex justify-between">
                                    {/* <div className="wrapper w-full max-w-[80vw] h-auto min-h-[58vh]  rounded-xl flex flex-col bg-white"> */}
                                    <div className="wrapper w-full max-w-[80vw] h-auto   flex flex-col">

                                        {
                                            filter == "Action Logs" ? (
                                                <>
                                                    <div className="action-section">
                                                        <div className="flex-grow">
                                                            {logs && (
                                                                // <div className="p-4 h-full">
                                                                <div className="py-4 h-full">

                                                                    {/* <div className="action-log-section flex justify-between gap-3">

                                                                        <h2 className="text-xl font-semibold text-color-gray-light mb-4">
                                                                            Action Logs
                                                                        </h2>

                                                                        <div className="copy-container flex justify-center gap-3 items-center"> <button onClick={copyToClipboard} className="ml-2">
                                                                            <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M10.4615 3.79425e-07H7.13321C5.6253 -1.63648e-05 4.43093 -2.47886e-05 3.49619 0.128211C2.5342 0.260171 1.75558 0.538225 1.14153 1.16476C0.527492 1.7913 0.254983 2.58577 0.125654 3.56733C-2.41964e-05 4.52109 -1.60384e-05 5.73976 3.71821e-07 7.27834V12.3488C3.71821e-07 13.9163 1.12579 15.2154 2.59734 15.4504C2.71055 16.0901 2.9272 16.636 3.36275 17.0805C3.85663 17.5844 4.47847 17.8012 5.21703 17.9025C5.92839 18 6.83282 18 7.95495 18H10.5066C11.6287 18 12.5332 18 13.2446 17.9025C13.9831 17.8012 14.6049 17.5844 15.0988 17.0805C15.5927 16.5765 15.8051 15.9421 15.9044 15.1885C16 14.4626 16 13.5398 16 12.3948V8.11683C16 6.97189 16 6.04902 15.9044 5.32319C15.8051 4.56961 15.5927 3.93511 15.0988 3.43118C14.6632 2.98677 14.1282 2.7657 13.5013 2.65019C13.271 1.14869 11.9977 3.79425e-07 10.4615 3.79425e-07ZM12.2087 2.52935C11.9602 1.78847 11.2719 1.25581 10.4615 1.25581H7.17949C5.61492 1.25581 4.50339 1.25715 3.66018 1.37282C2.83468 1.48606 2.35907 1.69844 2.01182 2.05275C1.66457 2.40707 1.45643 2.89236 1.34544 3.73467C1.23207 4.59503 1.23077 5.72917 1.23077 7.32558V12.3488C1.23077 13.1757 1.75281 13.878 2.47891 14.1315C2.46152 13.6209 2.46153 13.0435 2.46154 12.3948V8.11683C2.46152 6.97189 2.46151 6.04902 2.55714 5.32319C2.65644 4.56961 2.86887 3.93511 3.36275 3.43118C3.85663 2.92724 4.47847 2.7105 5.21703 2.60918C5.92839 2.51159 6.83282 2.51161 7.95495 2.51163H10.5066C11.1423 2.51162 11.7082 2.51161 12.2087 2.52935ZM4.23303 4.31917C4.46012 4.08747 4.77895 3.93639 5.38102 3.8538C6.0008 3.76877 6.82224 3.76744 8 3.76744H10.4615C11.6393 3.76744 12.4607 3.76877 13.0805 3.8538C13.6826 3.93639 14.0014 4.08747 14.2285 4.31917C14.4556 4.55088 14.6037 4.8762 14.6846 5.49052C14.7679 6.12291 14.7692 6.96104 14.7692 8.16279V12.3488C14.7692 13.5506 14.7679 14.3887 14.6846 15.0211C14.6037 15.6355 14.4556 15.9607 14.2285 16.1925C14.0014 16.4242 13.6826 16.5752 13.0805 16.6579C12.4607 16.7428 11.6393 16.7442 10.4615 16.7442H8C6.82224 16.7442 6.0008 16.7428 5.38102 16.6579C4.77895 16.5752 4.46012 16.4242 4.23303 16.1925C4.00595 15.9607 3.85789 15.6355 3.77694 15.0211C3.69361 14.3887 3.69231 13.5506 3.69231 12.3488V8.16279C3.69231 6.96104 3.69361 6.12291 3.77694 5.49052C3.85789 4.8762 4.00595 4.55088 4.23303 4.31917Z" fill="#282828" />
                                                                            </svg>
                                                                        </button>


                                                                            <span className="text-light-black">                                {copy}
                                                                            </span>
                                                                        </div>
                                                                    </div> */}

                                                                    <div className="max-h-[40vh] overflow-y-auto ">
                                                                        <pre className="text-[16px] font-medium text-dark-gray whitespace-pre-wrap break-words">
                                                                            {visibleLogs.map((log, index) => (
                                                                                <div
                                                                                    key={index}
                                                                                    className={`log-entry break-words  ${currentTime >= log.milliseconds
                                                                                        ? "highlighted"
                                                                                        : ""
                                                                                        }`} style={{ wordBreak: "break-word" }}
                                                                                    onClick={() => seekTo(log.milliseconds)}
                                                                                >
                                                                                    {log.content}
                                                                                </div>
                                                                            ))}



                                                                        </pre>
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>
                                                </>
                                            ) : (

                                                // <div className="p-4 summary-section">
                                                <div className="py-4 summary-section">

                                                    <div className="summary-log-section flex justify-between gap-3">
                                                        <h2 className="text-xl font-semibold text-color-gray-light mb-4">
                                                            Summary Logs
                                                        </h2>

                                                        <div className="copy-container flex justify-center gap-3 items-center">
                                                            <button onClick={copyToSummary} className="ml-2">
                                                                <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M10.4615 3.79425e-07H7.13321C5.6253 -1.63648e-05 4.43093 -2.47886e-05 3.49619 0.128211C2.5342 0.260171 1.75558 0.538225 1.14153 1.16476C0.527492 1.7913 0.254983 2.58577 0.125654 3.56733C-2.41964e-05 4.52109 -1.60384e-05 5.73976 3.71821e-07 7.27834V12.3488C3.71821e-07 13.9163 1.12579 15.2154 2.59734 15.4504C2.71055 16.0901 2.9272 16.636 3.36275 17.0805C3.85663 17.5844 4.47847 17.8012 5.21703 17.9025C5.92839 18 6.83282 18 7.95495 18H10.5066C11.6287 18 12.5332 18 13.2446 17.9025C13.9831 17.8012 14.6049 17.5844 15.0988 17.0805C15.5927 16.5765 15.8051 15.9421 15.9044 15.1885C16 14.4626 16 13.5398 16 12.3948V8.11683C16 6.97189 16 6.04902 15.9044 5.32319C15.8051 4.56961 15.5927 3.93511 15.0988 3.43118C14.6632 2.98677 14.1282 2.7657 13.5013 2.65019C13.271 1.14869 11.9977 3.79425e-07 10.4615 3.79425e-07ZM12.2087 2.52935C11.9602 1.78847 11.2719 1.25581 10.4615 1.25581H7.17949C5.61492 1.25581 4.50339 1.25715 3.66018 1.37282C2.83468 1.48606 2.35907 1.69844 2.01182 2.05275C1.66457 2.40707 1.45643 2.89236 1.34544 3.73467C1.23207 4.59503 1.23077 5.72917 1.23077 7.32558V12.3488C1.23077 13.1757 1.75281 13.878 2.47891 14.1315C2.46152 13.6209 2.46153 13.0435 2.46154 12.3948V8.11683C2.46152 6.97189 2.46151 6.04902 2.55714 5.32319C2.65644 4.56961 2.86887 3.93511 3.36275 3.43118C3.85663 2.92724 4.47847 2.7105 5.21703 2.60918C5.92839 2.51159 6.83282 2.51161 7.95495 2.51163H10.5066C11.1423 2.51162 11.7082 2.51161 12.2087 2.52935ZM4.23303 4.31917C4.46012 4.08747 4.77895 3.93639 5.38102 3.8538C6.0008 3.76877 6.82224 3.76744 8 3.76744H10.4615C11.6393 3.76744 12.4607 3.76877 13.0805 3.8538C13.6826 3.93639 14.0014 4.08747 14.2285 4.31917C14.4556 4.55088 14.6037 4.8762 14.6846 5.49052C14.7679 6.12291 14.7692 6.96104 14.7692 8.16279V12.3488C14.7692 13.5506 14.7679 14.3887 14.6846 15.0211C14.6037 15.6355 14.4556 15.9607 14.2285 16.1925C14.0014 16.4242 13.6826 16.5752 13.0805 16.6579C12.4607 16.7428 11.6393 16.7442 10.4615 16.7442H8C6.82224 16.7442 6.0008 16.7428 5.38102 16.6579C4.77895 16.5752 4.46012 16.4242 4.23303 16.1925C4.00595 15.9607 3.85789 15.6355 3.77694 15.0211C3.69361 14.3887 3.69231 13.5506 3.69231 12.3488V8.16279C3.69231 6.96104 3.69361 6.12291 3.77694 5.49052C3.85789 4.8762 4.00595 4.55088 4.23303 4.31917Z" fill="#282828" />
                                                                </svg>
                                                            </button>


                                                            <span className="text-light-black">                               {copiedSummary}
                                                            </span></div>
                                                    </div>

                                                    {summaryLogs ? (
                                                        <div className="max-h-[40vh] overflow-y-auto overflow-x-auto">
                                                            <pre className="text-[16px] font-medium text-dark-gray whitespace-pre-wrap break-words">

                                                                {summaryLogs}

                                                            </pre>
                                                        </div>


                                                    ) : (
                                                        // <div className="flex justify-center items-center">
                                                        //   <button
                                                        //     onClick={handleSummarizeLogs}
                                                        //     className="button bg-button-bg hover:bg-button-hover-color text-white text-[16px] rounded-lg p-2 px-3 gap-2 flex items-center space-x-2 my-12"
                                                        //     style={{
                                                        //       borderRadius: '6px',
                                                        //       background: 'var(--Grey-05, #282828)',
                                                        //       boxShadow: '-6px 0px 24px 6px rgba(255, 53, 231, 0.12), 6px -6px 24px 6px rgba(63, 53, 255, 0.12), 6px 6px 24px 6px rgba(255, 66, 53, 0.12), 6px 6px 24px 6px rgba(87, 255, 53, 0.12)',
                                                        //     }}
                                                        //   >
                                                        //     <svg width="21" height="24" viewBox="0 0 21 24" fill="none" xmlns="http://www.w3.org/2000/svg" >
                                                        //       <path d="M10.1454 5.01094C9.13433 3.85505 8.44232 1.83656 8.09889 0C7.75494 1.83694 7.06366 3.85584 6.05225 5.01173C5.04122 6.16683 3.27451 6.9577 1.66785 7.35098C3.27517 7.74347 5.04155 8.53388 6.05258 9.68981C7.06362 10.8453 7.75563 12.8642 8.09959 14.7007C8.44301 12.8638 9.13482 10.8449 10.1457 9.68902C11.1567 8.53355 12.9234 7.74305 14.5301 7.34977C12.9231 6.95728 11.1568 6.16645 10.1454 5.01094Z" fill="white" />
                                                        //       <path d="M16.7126 14.2659C16.1091 13.5759 15.695 12.3693 15.4899 11.2723C15.2844 12.3693 14.8717 13.5758 14.2675 14.2663C13.6633 14.956 12.6078 15.4288 11.6481 15.6637C12.6082 15.8986 13.6633 16.3706 14.2675 17.0611C14.8717 17.7512 15.2851 18.9577 15.4906 20.0547C15.6957 18.9572 16.1091 17.7512 16.7129 17.0607C17.3168 16.3706 18.3724 15.8981 19.332 15.6629C18.3725 15.4284 17.3168 14.956 16.7126 14.2659Z" fill="white" />
                                                        //       <path d="M6.00261 16.6266C5.83005 17.5476 5.48355 18.5609 4.97644 19.1404C4.4694 19.7195 3.58322 20.1163 2.77747 20.3135C3.58322 20.5111 4.4694 20.9068 4.97644 21.4866C5.48355 22.0661 5.83075 23.0785 6.0033 24C6.17569 23.0785 6.52236 22.0662 7.02964 21.4863C7.53634 20.9068 8.42269 20.5103 9.22828 20.3128C8.42273 20.1159 7.53634 19.7195 7.02931 19.14C6.52236 18.5609 6.17499 17.5477 6.00261 16.6266Z" fill="white" />
                                                        //     </svg>
                                                        //     {isSummarizing ? "Summarizing..." : "Summarize Logs"}
                                                        //   </button>
                                                        // </div>


                                                        <div className="empty-screen my-[60px]">
                                                            <Empty_Screen_Card image={summaryImage} onclick={handleSummarizeLogs} buttonName={isSummarizing ? "Summarizing..." : "Summarize Logs"} mainContent="Summarize action logs" subContent={<>
                                                                Go ahead and summarize logs for your  <br />
                                                                better understanding.
                                                            </>} />
                                                        </div>
                                                    )}
                                                </div>
                                            )
                                        }


                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div >
            </div >
        </>
    );
};

export default Share_Video_Summary;
